// extracted by mini-css-extract-plugin
export var collectionIntro = "collection-module--collectionIntro--z+4e7";